<script>
    import Header from './Header.svelte';
    import {mdiPlus,mdiPencil,mdiDelete,mdiPlaylistEdit} from '@mdi/js';
    import {Button,Modal,Card,Input,Checkbox,Field} from 'svelte-chota';
    import {api} from '../lib/api'
    import {onMount} from 'svelte';
    import {aoviSvelte} from 'aovi-svelte';

    let projects = [];
    let users = [];
    onMount(async ()=>{
        fetchProjects();
        users = await api.get('/user/list');
    })

    async function fetchProjects(){
        projects = await api.get('/project/list');
    }

    let usersModal = false;  
    
    let curProject = [];  
    async function showAddUserModal(project){
        curProject=project;
        usersModal = true;
    }

    async function assignUser(e,pid,uid){
        if(e.target.checked){
            await api.put(`/project/${pid}/users/${uid}`);
        }else{
            await api.delete(`/project/${pid}/users/${uid}`);
        }
        fetchProjects();
    }

    async function deleteProject(pid){
        if(confirm('Are you sure?'))
        {
            await api.delete(`/project/${pid}`);
            fetchProjects();
        }
    }

    function getUsername(uid,users){
        
        const user = users.find(u => u._id===uid);
        return user ? user.user : '';
    }

    let editModal = false;  
    let curForm;
    function openEditModal(project){
        curProject = project;
        curForm = aoviSvelte({
            name: curProject.name
        });
        editModal=true;
    }
    let curLoading = false;
    async function doEdit(){
        curLoading = true;
        let result = await api.put(`/project/${curProject._id}/name`,curForm.get());
        result.error ? curForm.load(result.error.aovi) : (fetchProjects(),editModal=false);
        curLoading=false;
    }
</script>

<Header title="Manage projects" button="Create Project" link="/admin/projects/create" icon={mdiPlus}/>
<table class="striped">
<tr>
    <th>Project</th>
    <th>Users</th>
    <th></th>
</tr>
{#each projects as project}
    <tr>
        <td><a href="/ide/{project.dir}">{project.name}</a></td>
        <td>
            {#each project.users as uid(uid)}
            <div>{getUsername(uid,users)}</div>
            {/each}
            <Button clear icon={mdiPlaylistEdit} on:click={()=>showAddUserModal(project)}/>
        </td>
        <td align="right">
            <Button icon={mdiPencil} on:click={()=>openEditModal(project)}/>
            <Button icon={mdiDelete} on:click={()=>deleteProject(project._id)}/>
        </td>
    </tr>
{:else}
    <tr><td colspan=2><p class="text-center text-grey">No projects</p></td></tr>
{/each}
</table>

<Modal bind:open={usersModal}>
    <Card>
        <h4 slot="header">Assign users to the project</h4>

        <div class="modal-body">
        {#each users as user}
            <p><Checkbox checked={curProject.users.includes(user._id)} on:change={e=>assignUser(e,curProject._id,user._id)}/> {user.user}</p>
        {/each}
        </div>
        
        <div slot="footer" class="is-center">
            <Button on:click={()=>usersModal=false}>Ready</Button>
        </div>
    </Card>
</Modal>

<Modal bind:open={editModal}>
    <Card>
        <h4 slot="header">Edit project name</h4>

        <Field error={$curForm.err.name}>
            <Input bind:value={$curForm.name} />
        </Field>
        
        <div slot="footer" class="is-center">
            <Button clear on:click={()=>editModal=false}>Cancel</Button>
            <Button on:click={doEdit} loading={curLoading}>Save</Button>
        </div>
    </Card>
</Modal>

<style>
    .modal-body{
        max-height: 300px;
        overflow-y: auto;
    }
</style>